<template>
  <div id="wrapper">
    <div id="content-wrapper">
      <div class="container-fluid">
        <div class="mb-4">
          <a href="#" @click.prevent="goBack">
            <i class="fas fa-arrow-left"></i>
            Back to Assets List
            <!-- trở về danh sách tài sản -->
          </a>
        </div>
        <div class="row">
          <div class="col-4">
            <form @submit.prevent="addItem" class="form-inline mb-3">
              <div class="form-group mr-2">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Assets Type ID"
                  v-model="added_item_code"
                  required
                />
              </div>
              <div class="form-group mr-3" style="width: 48%">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Assets Type"
                  v-model="added_item_name"
                  style="width: 100%;"
                  required
                />
              </div>
              <button class="btn btn-info" type="submit">
                <i class="fas fa-plus"></i>
                Add
                <!-- Thêm -->
              </button>
            </form>
            <b-table
              id="my-table"
              bordered
              head-variant="dark"
              hover
              responsive
              small
              selectable
              select-mode="single"
              table-variant="light"
              :fields="fields"
              :items="items"
            >
              <template v-slot:cell(type)="data">
                <input
                  type="text"
                  class="form-control"
                  :value="data.item.type"
                  required
                  @change="updateItem(data, $event)"
                />
              </template>
              <template v-slot:cell(code)="data">
                <input
                  type="text"
                  class="form-control"
                  :value="data.item.code"
                  required
                  @change="updateItemCode(data, $event)"
                />
              </template>
              <template v-slot:cell(deleted)="data">
                <button class="btn btn-danger" @click="deleteItem(data)">
                  <i class="fas fa-trash-alt"></i>
                </button>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "AssetTypes",
  data() {
    return {
      asset_search: "",
      fields: [
        {
          key: "code",
          label: "Assets Type ID",
          // label: "Mã loại tài sản",
          thStyle: { width: "120px !important" },
        },
        {
          key: "type",
          label: "Assets Type",
          // label: "Loại tài sản",
        },
        {
          key: "deleted",
          label: "",
          thStyle: { width: "50px !important" },
        },
      ],

      items: [],
      added_item_name: "",
      added_item_code: "",
    };
  },
  methods: {
    initData(items, params /*Search query from Asset Menu*/) {
      this.asset_search = params.search;
      this.items = items;
    },

    addItem() {
      if (!(this.added_item_name && this.added_item_name.length)) {
        this.$toast.error("Please input the name", "Error", { timeout: 2000 });
      } else {
        var isItemExist = this.items.filter(
          (assetType) =>
            assetType.type == this.added_item_name ||
            assetType.code == this.added_item_code
        );
        if (isItemExist.length > 0)
          this.$toast.error("The name already exists", "Error", {
            timeout: 2000,
          });
        else {
          axios
            .post("/api/AssetType", {
              type: this.added_item_name,
              code: this.added_item_code,
            })
            .then((res) => {
              this.items.push(res.data.item);
              this.added_item_name = "";
              this.added_item_code = "";
              this.$toast.success("Add successfully", "Success", {
                timeout: 2000,
              });
            })
            .catch((err) => {
              this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
              this.added_item_name = "";
            });
        }
      }
    },

    deleteItem(data) {
      this.$toast.question("Do you really want to delete?", "Warning", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Có</b></button>",
            (instance, toast) => {
              axios
                .delete(`api/AssetType/${data.item.id}`)
                .then((res) => {
                  this.items.splice(data.index, 1);
                  this.$toast.success("Delete successfully", "Success", {
                    timeout: 3000,
                  });
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "Error", {
                    timeout: 3000,
                  });
                });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>Không</button>",
            function(instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },

    updateItemCode(data, event) {
      var new_item_code = event.target.value;
      axios
        .put("/api/AssetType", {
          id: data.item.id,
          type: data.item.type,
          code: new_item_code,
        })
        .then((res) => {
          this.$toast.success("Update successfully", "Success", {
            timeout: 3000,
          });
          this.items[data.index].code = new_item_code;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
          event.target.value = data.item.code;
        });
    },

    updateItem(data, event) {
      var new_item_name = event.target.value;
      axios
        .put("/api/AssetType", {
          id: data.item.id,
          type: new_item_name,
        })
        .then((res) => {
          this.$toast.success("Update successfully", "Success", {
            timeout: 3000,
          });
          this.items[data.index].type = new_item_name;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
          event.target.value = data.item.name;
        });
    },

    goBack() {
      // this.$router.go(-1);
      this.$router.push({
        name: "asset",
        params: { q: this.asset_search },
      });
    },
  },

  beforeRouteEnter(to, from, next) {
    axios.get("/api/assettype").then((response) => {
      next((vm) => vm.initData(response.data.items, to.params));
    });
  },
};
</script>
